import { get, responseResult } from './api'
/**
 * 
 * @param {*} filters 
 * @returns 
 */
 export const getCommissions = (filters) => get('commissions', filters).then(responseResult)
